export default {
  LOCALE_KEY: 'klickpages_locale',
  DEFAULT_LOCALE: 'pt-BR',
};



/** WEBPACK FOOTER **
 ** ./src/i18n/config.js
 **/